import { graphqlRequest } from '../graphql/client';
import {
  CREATE_PRODUCT_CATEGORY_MUTATION,
  DELETE_PRODUCT_CATEGORY_MUTATION,
  PRODUCT_CATEGORIES_QUERY,
  UPDATE_PRODUCT_CATEGORY_MUTATION,
} from '../graphql/documents';
import { fetchProducts } from './productManagement';

export interface ManagedProductCategory {
  id: number;
  name: string;
  internalId?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface ProductCategoriesResponse {
  productCategories: ManagedProductCategory[];
}

interface CreateProductCategoryResponse {
  createProductCategory: ManagedProductCategory;
}

interface UpdateProductCategoryResponse {
  updateProductCategory: ManagedProductCategory;
}

interface DeleteProductCategoryResponse {
  deleteProductCategory: ManagedProductCategory;
}

export async function fetchProductCategories(): Promise<ManagedProductCategory[]> {
  const data = await graphqlRequest<ProductCategoriesResponse>(PRODUCT_CATEGORIES_QUERY);
  return data.productCategories;
}

export async function createProductCategory(input: {
  name: string;
  internalId: string;
  isActive: boolean;
}): Promise<ManagedProductCategory> {
  const data = await graphqlRequest<CreateProductCategoryResponse>(CREATE_PRODUCT_CATEGORY_MUTATION, { input });
  await fetchProducts().catch(() => undefined);
  return data.createProductCategory;
}

export async function updateProductCategory(input: {
  id: number;
  name: string;
  internalId: string;
  isActive: boolean;
}): Promise<ManagedProductCategory> {
  const data = await graphqlRequest<UpdateProductCategoryResponse>(UPDATE_PRODUCT_CATEGORY_MUTATION, { input });
  await fetchProducts().catch(() => undefined);
  return data.updateProductCategory;
}

export async function deleteProductCategory(id: number): Promise<ManagedProductCategory> {
  const data = await graphqlRequest<DeleteProductCategoryResponse>(DELETE_PRODUCT_CATEGORY_MUTATION, { id });
  await fetchProducts().catch(() => undefined);
  return data.deleteProductCategory;
}
